import React from "react";
import { Label } from "@/components/atoms";
import type { FormFieldProps } from "./FormField.types";

export const FormField: React.FC<FormFieldProps> = ({
  label,
  error,
  children,
  required = false,
  helperText,
  className = "",
}) => {
  return (
    <div className={`space-y-1 ${className}`}>
      <Label required={required}>{label}</Label>
      {children}
      {error && <p className="text-sm text-danger">{error}</p>}
      {helperText && !error && (
        <p className="text-xs text-white/45">{helperText}</p>
      )}
    </div>
  );
};
